<div class="subscription-header">
    <div class="subscription-details">
        <div class="plan-name">
            <p-message severity="secondary" variant="outlined">
                {{planDisplayName}}
                @if (isTrial) {
                    <span class="trial-indicator"> • {{ 'plan.trialPeriodBadge' | transloco }}</span>
                }
            </p-message>
        </div>

        <span class="plan-price">
            {{displayPrice | customCurrency:0:displayCurrency}}
            <span class="plan-currency">{{displayCurrency | uppercase}}{{ 'plan.perMonth' | transloco }}</span>
        </span>

        @if (currentSubscription && currentSubscription.planType !== 'none') {
            @if (isTrial) {
                <div class="trial-info" [class.expiring-soon]="isTrialExpiringSoon">
                    <div class="trial-time">
                        <strong>{{getTrialStatusText()}}</strong> {{ 'plan.trialFreeSuffix' | transloco }}
                    </div>
                    <div class="trial-end">
                        {{ 'plan.trialEndsOn' | transloco: { date: (currentSubscription.endDate | date: 'dd/MM/yyyy') } }}
                    </div>
                </div>
            } @else {
                <div class="plan-renew">
                    {{ 'plan.renewsOn' | transloco: { date: (currentSubscription.endDate | date: 'dd/MM/yyyy') } }}
                </div>
            }
        }
    </div>
    <p-button *ngIf="false" [label]="'plan.cancelSubscription' | transloco" severity="secondary" (onClick)="cancelSubscription()"/>
</div>

<p-confirmdialog>
    <ng-template #message let-message>
        <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
            <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmdialog>